// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-0-2","title":"styles_title__LOasI"};